import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import PageShell from '../components/PageShell';
import Tabs from '../components/Tabs';
import { resolveTabs } from '../i18n/resolveTabs';
import MappingPage from './MappingPage';
import BsMappingPage from './BsMappingPage';

/* Mapping — correspondance comptes → lignes de reporting, sorti du hub
   Structure (demande Olivier, 2026-08-12) : la structure DESSINE les lignes,
   le mapping y BRANCHE la comptabilité — deux gestes distincts. */
const TAB_DEFS = [
  { id: 'pl-mapping', labelKey: 'finance:input.tabs.pl-mapping' },
  { id: 'bs-mapping', labelKey: 'finance:input.tabs.bs-mapping' },
];

export default function FinancialsMappingHub({ activeTenant, addToast }) {
  const { t } = useTranslation();
  const [tab, setTab] = useState('pl-mapping');

  return (
    <PageShell framed title={t('nav:items.financials-mapping-hub')}>
      <Tabs tabs={resolveTabs(TAB_DEFS, t)} active={tab} onChange={setTab} />
      <div className="page-shell__panel">
        {tab === 'pl-mapping' && (
          <MappingPage embedded activeTenant={activeTenant} addToast={addToast} />
        )}
        {tab === 'bs-mapping' && (
          <BsMappingPage embedded activeTenant={activeTenant} addToast={addToast} />
        )}
      </div>
    </PageShell>
  );
}
